// client/src/components/admin/AdminLayout.js
import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 60);
    return () => clearTimeout(timer);
  }, []);

  // Automatically redirect base /admin/dashboard to /admin/dashboard/quotes
  useEffect(() => {
    if (
      location.pathname === '/admin/dashboard' ||
      location.pathname === '/admin/dashboard/'
    ) {
      navigate('/admin/dashboard/quotes', { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/admin/login');
  };

  const getNavLinkClass = ({ isActive }) =>
    isActive ? 'admin-nav-link active' : 'admin-nav-link';

  const getSectionTitle = () => {
    if (location.pathname.includes('/products')) return 'Product Catalog Management';
    if (location.pathname.includes('/messages')) return 'Visitor Inquiries & Messages';
    return 'Clinical Quote Requests';
  };

  return (
    <div className={`admin-layout ${isVisible ? 'is-visible' : ''}`}>
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <div className="admin-brand-logo">
            <img src="/images/makah-medics-logo.jpeg" alt="Makah Medics" />
          </div>
          <div>
            <h2 className="admin-title">Makah Medics</h2>
            <span className="admin-subtitle">Admin Control Center</span>
          </div>
        </div>

        <div className="admin-nav-group-label">Operations</div>
        <nav className="admin-nav">
          <NavLink to="/admin/dashboard/quotes" className={getNavLinkClass}>
            <span className="admin-nav-icon">
              <i className="fas fa-file-invoice-dollar"></i>
            </span>
            <span>Quote Requests</span>
          </NavLink>

          <NavLink to="/admin/dashboard/products" className={getNavLinkClass}>
            <span className="admin-nav-icon">
              <i className="fas fa-boxes"></i>
            </span>
            <span>Product Catalog</span>
          </NavLink>

          <NavLink to="/admin/dashboard/messages" className={getNavLinkClass}>
            <span className="admin-nav-icon">
              <i className="fas fa-envelope-open-text"></i>
            </span>
            <span>Visitor Messages</span>
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <Link to="/" className="admin-view-site-btn">
            <i className="fas fa-external-link-alt"></i>
            <span>View Live Website</span>
          </Link>
          <button type="button" className="admin-logout-btn" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i>
            <span>Sign Out</span>
          </button>
        </div>
      </aside>

      <div className="admin-main-Column">
        <header className="admin-topbar">
          <div className="admin-topbar-left">
            <span className="admin-breadcrumb">Dashboard / {getSectionTitle()}</span>
          </div>
          <div className="admin-topbar-right">
            <div className="admin-user-pill">
              <span className="status-dot"></span>
              <i className="fas fa-user-shield"></i>
              <span>Administrator</span>
            </div>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
